import { ActionButton, OfficeButton, Show, TableComponent } from "components";
import { useNonProportionalPayments } from "hooks/data/use-treaties";
import { useMatch } from "react-location";
import { LocationGenerics } from "router/location";
import CreatePaymentCOntainer from "./create";
import { useAppNavigate, useAppSearch } from "_graphql/cache/auth";
import UpdateNonProportionalPaymentCOntainer from "./update";
import { GetNonProportionalTreatyPayments_getNonProportionalTreatyPayments } from "_graphql/queries/__generated__/GetNonProportionalTreatyPayments";
import RemoveContainer from "./remove";
import ViewPaymentReceiptContainer from "./view-receipt";
import DistributePaymentContainer from "./distribute";
import { withPermissions } from "utils";
import { FC } from "react";

type Props = {};

const NonProportionalPayments: FC<Props> = () => {
  const { params } = useMatch<LocationGenerics>();
  const searchParams = useAppSearch();
  const navigate = useAppNavigate();
  const { payments, loading, refetch } = useNonProportionalPayments({
    filter: {
      treaty_id: params?.treaty || "",
    },
  });
  return (
    <>
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            title={""}
            loading={loading}
            columns={[
              {
                accessor: "installment_type",
                name: "Installment #",
              },
              {
                accessor: "id",
                name: "Payment Type",
                render: (value: any) => {
                  const details = JSON.parse(value?.treaty_payment_details);
                  return (
                    <div className="flex flex-row leading-0">
                      <span>{details?.payment_type}</span>
                    </div>
                  );
                },
              },
              {
                accessor: "id",
                name: "Bank Name",
                render: (value: any) => {
                  const details = JSON.parse(value?.treaty_payment_details);
                  return (
                    <div className="flex flex-row leading-0">
                      <span>{details?.payment_from?.bank_name}</span>
                    </div>
                  );
                },
              },
              {
                accessor: "id",
                name: "Beneficiary Bank Name",
                render: (value: any) => {
                  const details = JSON.parse(value?.treaty_payment_details);
                  return (
                    <div className="flex flex-row leading-0">
                      <span>{details?.payment_to || "N/A"}</span>
                    </div>
                  );
                },
              },
              {
                accessor: "treaty_payment_amount",
                name: "Payment Amt",
              },
              {
                accessor: "created_at",
                name: "Payment Date	",
              },
              {
                accessor: "distribute_payment",
                name: "Dustribution Status",
              },
              {
                accessor: "updated_at",
                name: "Last Payment Upate",
              },
              {
                accessor: "id",
                name: "Actions",
                render: (
                  value: GetNonProportionalTreatyPayments_getNonProportionalTreatyPayments
                ) => (
                  <div>
                    {withPermissions([
                      "*:*",
                      "treaties:*",
                      "treaties:manage",
                      "treaties:payments",
                    ])(
                      <ActionButton
                        tooltip="Update Payment Record"
                        action={"update"}
                        onClick={() =>
                          navigate({
                            search(prev) {
                              return {
                                ...prev,
                                id: value?.treaty_n_p_payment_id || "",
                                modal: "update",
                              };
                            },
                          })
                        }
                      />
                    )}
                    {withPermissions([
                      "*:*",
                      "treaties:*",
                      "treaties:manage",
                      "treaties:payments",
                    ])(
                      <ActionButton
                        tooltip="Delete Payment Record"
                        action={"remove"}
                        onClick={() =>
                          navigate({
                            search(prev) {
                              return {
                                ...prev,
                                id: value?.treaty_n_p_payment_id || "",
                                modal: "remove",
                              };
                            },
                          })
                        }
                      />
                    )}
                    <ActionButton
                      tooltip="Generate Payment Receipt"
                      action={"clone"}
                      onClick={() =>
                        navigate({
                          search(prev) {
                            return {
                              ...prev,
                              id: value?.treaty_n_p_payment_id || "",
                              modal: "export",
                            };
                          },
                        })
                      }
                    />
                    <Show if={value?.distribute_payment === "NOT DISTRIBUTED"}>
                      {withPermissions([
                        "*:*",
                        "treaties:*",
                        "treaties:manage",
                        "treaties:payments",
                      ])(
                        <ActionButton
                          tooltip="Distribute Payment"
                          action={"distribute"}
                          onClick={() =>
                            navigate({
                              search(prev) {
                                return {
                                  ...prev,
                                  id: value?.treaty_n_p_payment_id || "",
                                  modal: "distribute",
                                };
                              },
                            })
                          }
                        />
                      )}
                    </Show>
                    {/* <ActionButton
                      tooltip="Clear Paymnt Cheque"
                      action={"distribute"}
                      onClick={() => { }}
                    /> */}
                  </div>
                ),
              },
            ]}
            data={payments}
            renderActions={() => (
              <>
                <OfficeButton
                  onClick={() =>
                    navigate({
                      search(prev) {
                        return {
                          ...prev,
                          modal: "create",
                        };
                      },
                    })
                  }
                >
                  Make payment
                </OfficeButton>
              </>
            )}
            refetch={refetch}
          />
        </div>
      </div>

      <CreatePaymentCOntainer
        open={searchParams?.modal === "create"}
        setOpen={(val) =>
          navigate({
            search(prev) {
              return {
                ...prev,
                modal: val ? "create" : undefined,
              };
            },
          })
        }
      />

      {searchParams?.id && searchParams?.modal === "update" && (
        <UpdateNonProportionalPaymentCOntainer
          open={searchParams?.modal === "update"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  id: val ? searchParams.id : undefined,
                  modal: val ? "update" : undefined,
                };
              },
            })
          }
        />
      )}
      {searchParams?.id && searchParams?.modal === "remove" && (
        <RemoveContainer
          open={searchParams?.modal === "remove"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "remove" : undefined,
                  id: val ? searchParams?.id : undefined,
                };
              },
            })
          }
        />
      )}

      {searchParams?.id && searchParams?.modal === "distribute" && (
        <DistributePaymentContainer
          open={searchParams?.modal === "distribute"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "distribute" : undefined,
                  id: val ? searchParams?.id : undefined,
                };
              },
            })
          }
        />
      )}
      {searchParams?.id && searchParams?.modal === "export" && (
        <ViewPaymentReceiptContainer
          open={searchParams?.modal === "export"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "export" : undefined,
                  id: val ? searchParams?.id : undefined,
                };
              },
            })
          }
        />
      )}
    </>
  );
};

export default NonProportionalPayments;
